import { Button, Modal, Tab, Nav, Card } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Images from "../../Images";
import { GalleryItem } from "../types/GalleryItem";
import Files from "../../Files";
import GalleryProducts from "../../GalleryProducts";

const GallerySelector = (props: any) => {
  const handleSave = props.handleSave;
  const galleryItems = props.galleryItems;
  useEffect(() => {
    setItems(galleryItems);
  }, [galleryItems]);
  const [show, setShow] = useState(false);
  const [items, setItems]: [GalleryItem[] | undefined, Function] = useState();

  const handleClose = () => {
    setItems(galleryItems);
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const handleSelected = (item: GalleryItem) => {
    let changed = false;
    const selected = items
      ? items.map((s: GalleryItem) => {
          if (
            (item.type === "file" && item.url === s.url) ||
            (item?.image?.original &&
              item?.image?.original === s?.image?.original)
          ) {
            changed = true;
            return item;
          } else if (
            item.type === "product" &&
            item?.product?.code === s.product?.code
          ) {
            changed = true;
            return item;
          }
          return s;
        })
      : null;
    if (!changed && selected) {
      selected.push(item);
    }
    setItems(selected || [item]);
  };
  const onSave = () => {
    handleSave(items);
    setShow(false);
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Add Items <FontAwesomeIcon icon="plus" />
      </Button>

      <Modal show={show} onHide={handleClose} size="xl" scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>Gallery Selector</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tab.Container
            defaultActiveKey="images"
            id="gallery-selector-modal-tabs"
          >
            <Card>
              <Card.Header>
                <Nav variant="tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="images" className="border-bottom-0">
                      Images
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="files" className="border-bottom-0">
                      Files
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="products" className="border-bottom-0">
                      Products
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Header>
              <Card.Body>
                <Tab.Content>
                  <Tab.Pane eventKey="images">
                    <Images
                      selectMode={true}
                      selectedItems={items}
                      handleSelected={handleSelected}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="files">
                    <Files
                      galleryMode={true}
                      galleryItems={items}
                      handleSelected={handleSelected}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="products">
                    <GalleryProducts
                      selectedItems={items}
                      handleSelected={handleSelected}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Card.Body>
            </Card>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GallerySelector;
